import React, { useState } from "react";
import { RiMenuAddFill } from "react-icons/ri";
import { FiPlusSquare, FiMinusSquare, FiSearch } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";

// --------------------------- Category_Select_Pop2 ---------------------------
const Category_Select_Pop2 = ({ onClose }) => {
  const [showLayouts, setShowLayouts] = useState(Array(8).fill(false));
  const [expandedRows, setExpandedRows] = useState({});
  const [topAddClicked, setTopAddClicked] = useState({});
  const data = ["Agriculture & Food", "Agriculture & Food", "Agriculture & Food"];

  const toggleLayout = (index) => {
    const updated = [...showLayouts];
    updated[index] = !updated[index];
    setShowLayouts(updated);
  };

  const toggleSearch = (outerIdx, innerIdx) => {
    setExpandedRows((prev) => {
      const outer = prev[outerIdx] || {};
      return {
        ...prev,
        [outerIdx]: {
          ...outer,
          [innerIdx]: !outer[innerIdx],
        },
      };
    });
  };

  const handleTopAddClick = (outerIdx) => {
    setTopAddClicked((prev) => ({
      ...prev,
      [outerIdx]: !prev[outerIdx],
    }));

    setShowLayouts((prev) => {
      const updated = [...prev];
      updated[outerIdx] = true;
      return updated;
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-lg w-[750px] max-h-[85vh] overflow-y-auto p-6 relative">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">Select Category</h2>
            <p className="text-sm text-gray-500">
              You can select categories and subcategories
            </p>
          </div>
          <button
            className="text-gray-500 text-2xl hover:text-gray-800"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <div className="flex items-center max-w-[550px] px-4 mx-auto border rounded-md bg-gray-200 mb-4">
          <input
            placeholder="Search"
            className="flex-1 bg-gray-200 p-2 focus:outline-none"
          />
          <FiSearch className="text-lg text-gray-600 mr-2" />
        </div>

        <div className="space-y-4">
          {Array.from({ length: 8 }).map((_, outerIdx) => (
            <div key={outerIdx} className="rounded-md">
              <div className="flex gap-3 border-b p-2 items-center">
                <RiMenuAddFill
                  className="text-xl text-gray-600 cursor-pointer"
                  onClick={() => handleTopAddClick(outerIdx)}
                />
                <AiOutlineDelete className="text-xl text-gray-600" />
                {showLayouts[outerIdx] ? (
                  <FiMinusSquare
                    className="text-xl text-blue-500 cursor-pointer"
                    onClick={() => toggleLayout(outerIdx)}
                  />
                ) : (
                  <FiPlusSquare
                    className="text-xl text-blue-500 cursor-pointer"
                    onClick={() => toggleLayout(outerIdx)}
                  />
                )}
                <input type="checkbox" className="w-5 h-5 accent-blue-500" />
                <span className="text-gray-700 font-medium">Agriculture & Food</span>
              </div>

              {showLayouts[outerIdx] && (
                <div className="p-3 rounded-md transition-all duration-300">
                  {topAddClicked[outerIdx] && (
                    <div className="mb-4 ps-10">
                      <div className="flex border rounded-full max-w-md w-full">
                        <div className="bg-gray-400 rounded-s-full px-3 flex items-center text-white">
                          <span>00</span>
                        </div>
                        <input
                          type="text"
                          placeholder="| 00 enter your SAC code"
                          className="flex-1 text-sm px-3 py-1 focus:outline-none"
                        />
                        <button className="bg-gray-400 text-white px-4 rounded-e-full text-sm hover:bg-gray-500">
                          Add
                        </button>
                      </div>
                    </div>
                  )}
                  {data.map((code, innerIdx) => (
                    <div key={innerIdx}>
                      <div className="flex gap-3 items-center ps-10 py-2">
                        {innerIdx < 2 ? (
                          <RiMenuAddFill
                            className="text-xl text-gray-600 cursor-pointer"
                            onClick={() => toggleSearch(outerIdx, innerIdx)}
                          />
                        ) : (
                          <div className="w-[24px]" />
                        )}
                        <AiOutlineDelete className="text-xl text-gray-600" />
                        <FiPlusSquare className="text-xl text-gray-600" />
                        <input type="checkbox" className="w-5 h-5 accent-blue-500" />
                        <span className="text-gray-700">{code}</span>
                      </div>
                      {expandedRows[outerIdx]?.[innerIdx] && (
                        <div className="ps-16 mb-3">
                          <div className="flex border rounded-full max-w-md w-full">
                            <div className="bg-gray-400 rounded-s-full px-3 flex items-center text-white">
                              <span>01</span>
                            </div>
                            <input
                              type="text"
                              placeholder="| 01 enter your SAC code"
                              className="flex-1 text-sm px-3 py-1 focus:outline-none"
                            />
                            <button className="bg-gray-400 text-white px-4 rounded-e-full text-sm hover:bg-gray-500">
                              Add
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="text-right">
            <button
              onClick={onClose}
              type="submit"
              className="bg-[#008bcf] text-white px-5 py-2 rounded hover:bg-[#007bb5]"
            >
              Add Product
            </button>
          </div>
      </div>
    </div>
  );
};

// --------------------------- Category_Select_Pop ---------------------------
const Category_Select_Pop = ({ openSecondModal }) => {
  const [showLayouts, setShowLayouts] = useState(Array(8).fill(false));
  const [expandedRows, setExpandedRows] = useState({});
  const [topAddClicked, setTopAddClicked] = useState({});
  const data = ["Agriculture & Food", "Agriculture & Food", "Agriculture & Food"];

  const toggleLayout = (index) => {
    const updated = [...showLayouts];
    updated[index] = !updated[index];
    setShowLayouts(updated);
  };

  const toggleSearch = (outerIdx, innerIdx) => {
    setExpandedRows((prev) => {
      const outer = prev[outerIdx] || {};
      return {
        ...prev,
        [outerIdx]: {
          ...outer,
          [innerIdx]: !outer[innerIdx],
        },
      };
    });
  };

  const handleTopAddClick = (outerIdx) => {
    setTopAddClicked((prev) => ({
      ...prev,
      [outerIdx]: !prev[outerIdx],
    }));

    setShowLayouts((prev) => {
      const updated = [...prev];
      updated[outerIdx] = true;
      return updated;
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-lg w-[750px] max-h-[85vh] overflow-y-auto p-6 relative">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">Select Category</h2>
            <p className="text-sm text-gray-500">
              You can select categories and subcategories
            </p>
          </div>
          <button
            className="text-gray-500 text-2xl hover:text-gray-800"
            onClick={openSecondModal}
          >
            &times;
          </button>
        </div>

        <div className="flex items-center max-w-[550px] px-4 mx-auto border rounded-md bg-gray-200 mb-4">
          <input
            placeholder="Search"
            className="flex-1 bg-gray-200 p-2 focus:outline-none"
          />
          <FiSearch className="text-lg text-gray-600 mr-2" />
        </div>

        <div className="space-y-4">
          {Array.from({ length: 8 }).map((_, outerIdx) => (
            <div key={outerIdx} className="rounded-md">
              <div className="flex gap-3 border-b p-2 items-center">
                <RiMenuAddFill
                  className="text-xl text-gray-600 cursor-pointer"
                  onClick={() => handleTopAddClick(outerIdx)}
                />
                <AiOutlineDelete className="text-xl text-gray-600" />
                {showLayouts[outerIdx] ? (
                  <FiMinusSquare
                    className="text-xl text-blue-500 cursor-pointer"
                    onClick={() => toggleLayout(outerIdx)}
                  />
                ) : (
                  <FiPlusSquare
                    className="text-xl text-blue-500 cursor-pointer"
                    onClick={() => toggleLayout(outerIdx)}
                  />
                )}
                <input type="checkbox" className="w-5 h-5 accent-blue-500" />
                <span className="text-gray-700 font-medium">Agriculture & Food</span>
              </div>

              {showLayouts[outerIdx] && (
                <div className="p-3 rounded-md transition-all duration-300">
                  {topAddClicked[outerIdx] && (
                    <div className="mb-4 ps-10">
                      <div className="flex border rounded-full max-w-md w-full">
                        <div className="bg-gray-400 rounded-s-full px-3 flex items-center text-white">
                          <span>00</span>
                        </div>
                        <input
                          type="text"
                          placeholder="| 00 enter your SAC code"
                          className="flex-1 text-sm px-3 py-1 focus:outline-none"
                        />
                        <button className="bg-gray-400 text-white px-4 rounded-e-full text-sm hover:bg-gray-500">
                          Add
                        </button>
                      </div>
                    </div>
                  )}
                  {data.map((code, innerIdx) => (
                    <div key={innerIdx}>
                      <div className="flex gap-3 items-center ps-10 py-2">
                        {innerIdx < 2 ? (
                          <RiMenuAddFill
                            className="text-xl text-gray-600 cursor-pointer"
                            onClick={() => toggleSearch(outerIdx, innerIdx)}
                          />
                        ) : (
                          <div className="w-[24px]" />
                        )}
                        <AiOutlineDelete className="text-xl text-gray-600" />
                        <FiPlusSquare className="text-xl text-gray-600" />
                        <input type="checkbox" className="w-5 h-5 accent-blue-500" />
                        <span className="text-gray-700">{code}</span>
                      </div>
                      {expandedRows[outerIdx]?.[innerIdx] && (
                        <div className="ps-16 mb-3">
                          <div className="flex border rounded-full max-w-md w-full">
                            <div className="bg-gray-400 rounded-s-full px-3 flex items-center text-white">
                              <span>01</span>
                            </div>
                            <input
                              type="text"
                              placeholder="| 01 enter your SAC code"
                              className="flex-1 text-sm px-3 py-1 focus:outline-none"
                            />
                            <button className="bg-gray-400 text-white px-4 rounded-e-full text-sm hover:bg-gray-500">
                              Add
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        
      </div>
    </div>
  );
};

// --------------------------- EditLinkUnitModal ---------------------------
const EditLinkUnitModal = ({ onClose, reopenFirst, openPop2 }) => {
  const [hsn, setHsn] = useState("01");
  const [defaultUnit, setDefaultUnit] = useState("Kg");
  const [otherUnits, setOtherUnits] = useState("Ton, Pcs");
  const [showModalSave, setShowModalSave] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModalSave(true);
  };

  const handleDone = () => {
    setShowModalSave(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-md shadow-lg w-[450px] p-6 relative">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            Edit Link Unit to HSN
          </h2>
          <button className="text-gray-600 text-xl" onClick={reopenFirst}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              HSN<span className="text-red-500">*</span>
            </label>
            <select
              value={hsn}
              onClick={openPop2}
              className="w-full border rounded px-3 py-2 mt-1"
              required
            >
              <option value="01">01</option>
              <option value="02">02</option>
              <option value="03">03</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Default Unit<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={defaultUnit}
              onClick={openPop2}
              className="w-full border rounded px-3 py-2 mt-1"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Other Allowed Units<span className="text-red-500">*</span>
            </label>
            <textarea
              value={otherUnits}
              onClick={openPop2}
              rows={3}
              className="w-full border rounded px-3 py-2 mt-1"
              required
            ></textarea>
          </div>

          <div className="text-right">
            <button
              type="submit"
              className="bg-[#008bcf] text-white px-5 py-2 rounded hover:bg-[#007bb5]"
            >
              Save
            </button>
          </div>
        </form>
      </div>

      {showModalSave && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-72 gap-4 flex flex-col py-5 text-center relative">
            <div className="flex w-full justify-center">
              <FaCheckCircle className="text-6xl text-green-600 text-center" />
            </div>
            <div className="flex justify-center items-center mb-2">
              <h3 className="text-md text-center font-semibold">
                Unit Saved Successfully!
              </h3>
            </div>
            <div className="flex justify-center gap-5">
              <button
                onClick={handleDone}
                className="bg-green-600 text-white px-4 py-1 rounded"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --------------------------- App ---------------------------
export default function App() {
  const [showFirst, setShowFirst] = useState(true);
  const [showSecond, setShowSecond] = useState(false);
  const [showPop2, setShowPop2] = useState(false);

  return (
    <>
      {showFirst && (
        <Category_Select_Pop
          openSecondModal={() => {
            setShowFirst(false);
            setShowSecond(true);
          }}
        />
      )}

      {showSecond && (
        <EditLinkUnitModal
          onClose={() => setShowSecond(false)}
          reopenFirst={() => {
            setShowSecond(false);
            setShowFirst(true);
          }}
          openPop2={() => setShowPop2(true)}
        />
      )}

      {showPop2 && (
        <Category_Select_Pop2
          onClose={() => setShowPop2(false)}
        />
      )}
    </>
  );
}
